// Google Workspace 監査のチェックシート: カタログ全項目 + 診断結果 + 推奨対応を一覧する。
// 行の組み立て・表・CSV・未実施の案内はドメイン非依存の ui/checksheet が持ち、
// ここは GW のカタログと文言だけを渡す（SF 版と同じ骨格を共有し、表示が食い違わないようにする）。
import { CHECKS, CATEGORIES, SEVERITY_LABELS, type Finding } from "./audit-data";
import { buildChecksheetRows, renderChecksheet, type ChecksheetRow } from "../ui/checksheet";

const INTRO =
  "Google Workspace 監査で実施するチェック項目の一覧です。各項目の「何を確認するか」「なぜ重要か」「診断結果」「推奨対応」を確認できます。行を選択すると詳細が開きます。";

const NOT_RUN_NOTICE =
  "まだ診断を実行していません。「接続」タブで Google Workspace と接続すると、各項目に診断結果が入ります。";

export interface GwChecksheetDeps {
  // 診断結果。未注入（undefined）は「診断未実行」を意味し、全項目が未実施になる。
  // 空配列は「診断は実行したが結果が 1 件も無い」で、全項目が未評価になる（未実施とは区別する）。
  //
  // toFindings の notEvaluated は受け取らない: バックエンドの coverage.notEvaluated は
  // 「カタログ − evaluated」の補集合なので、「findings に無い = 未評価」と常に一致する。
  readonly findings?: readonly Finding[];
}

export function buildGwChecksheetRows(deps: GwChecksheetDeps): ChecksheetRow[] {
  return buildChecksheetRows({
    checks: CHECKS,
    categories: CATEGORIES,
    // findings === undefined（未実行）と []（実行したが結果なし）の区別を潰さないよう、キーごと省略する。
    ...(deps.findings !== undefined ? { findings: deps.findings } : {}),
  });
}

export function renderGwChecksheet(root: HTMLElement, deps: GwChecksheetDeps): void {
  renderChecksheet(root, {
    intro: INTRO,
    notRunNotice: NOT_RUN_NOTICE,
    caption: "Google Workspace 監査チェックシート",
    rows: buildGwChecksheetRows(deps),
    categories: CATEGORIES,
    // 重大度の表記は GW ドメインの用語に合わせる（critical =「致命的」）。
    severityLabels: SEVERITY_LABELS,
    csvFilename: "google-workspace-checksheet.csv",
  });
}
